"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationApiTest = exports.isStringOrNullType = exports.INTEGRATION_TEST_LOCATION_API_URL = void 0;
const tslib_1 = require("tslib");
const argvLocationApiUrl = global.argv ? global.argv.locationApiUrl : '';
exports.INTEGRATION_TEST_LOCATION_API_URL = argvLocationApiUrl || 'https://webexintegrationblue.2ea261f1307d4469934a.northeurope.aksapp.io';
const isStringOrNullType = (s) => s === null || typeof s == 'string';
exports.isStringOrNullType = isStringOrNullType;
class LocationApiTest {
    static checkStringParameter(paramName, paramValue) {
        it(`${paramName} must be present in params`, () => {
            global.expect(paramValue).to.exist;
            global.expect(paramValue).not.empty;
        });
    }
    static checkCountryCode(countryCode) {
        this.checkStringParameter('countryCode', countryCode);
    }
    static checkLanguageCode(languageCode) {
        this.checkStringParameter('languageCode', languageCode);
    }
    static checkIfErrorsAreNotThrown(loadCountriesApiPromise) {
        describe('--- Check if promise does not throw errors ---', () => {
            it('should not throw errors', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield global.expect(loadCountriesApiPromise).not.to.be
                    .rejected;
            }));
        });
    }
}
exports.LocationApiTest = LocationApiTest;
